export default __webpack_public_path__ + "static/media/3.cffe1634.png";